import Button from 'components/Button';
import styled from 'styled-components';
import { IPrevNextButtonProps } from './TaskAttachmentsModal-type';

export const AttachmentFileHolder = styled.div`
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PrevNextButton = styled(Button)<IPrevNextButtonProps>`
  position: absolute;
  ${({ side }) => side}: 0;
  top: 2rem;
  transform: translateY(-50%);
`;

export const AttachmentModalImageHolder = styled.div`
  display: block;
  flex: 1;
  overflow: hidden;
  min-height: 70vh;

  & iframe {
    min-height: 70vh;
  }
`;

export const AttachmentModalDownloadLink = styled.a`
  display: block;
  margin-block: 0 1rem;
`;

export const AttachmentModalInfo = styled.p`
  margin-block: 0 1rem;
  line-height: 20px;
  bottom: 0;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  color: var(--exact-white);
  display: inline-block;
`;
